<template>
	<div></div>
</template>

<style scoped>
	ol {
		font-size: 16px;
	}

	ol li {
		margin-bottom: 8px;
	}

	li.disabled {
		opacity: 0.3;
	}

	li.active {
		font-weight: 700;
	}
</style>

<script>
	import * as types from 'vx/mutation-types'
	import { Sites as SiteActions, App as AppActions, User as UserActions } from 'vx/actions'

	export default {
		data() {
			return {};
		},

		vuex: {
			actions: {
				setTitle: AppActions.title,
				selectSite: SiteActions.select
			}
		},

		ready() {
			this.setTitle('');
			this.selectSite({});

			sessionStorage.removeItem('token');
			localStorage.removeItem('site');

			this.$store.dispatch(types.SET_AUTHORIZED, false);

			this.$router.go({ name: 'login' });
		}
	};
</script>



// WEBPACK FOOTER //
// logout.vue?b051b648